__turbopack_context__.v({
  "errorItem": "AttachmentTray-module__ma-mdq__errorItem",
  "errorList": "AttachmentTray-module__ma-mdq__errorList",
  "list": "AttachmentTray-module__ma-mdq__list",
  "tray": "AttachmentTray-module__ma-mdq__tray",
});
